$(function() {
	// Validation
	$("#login-form").validate({
		// Rules for form validation
		rules : {
			alias : {
				required : true,
				alias : true
			},
			password : {
				required : true,
				minlength : 3,
				maxlength : 20
			}
		},
		errorElement: 'span',
        errorClass: 'error-datos',

		// Messages for form validation
		messages : {
			alias : {
				required : 'Por favor inserte su alias',
				alias : 'Por favor inserte un alias válido'
			},
			password : {
				required : 'Por favor inserte su password'
			}
		},

		// Do not change code below
		errorPlacement : function(error, element) {
			error.insertAfter(element.parent());
		}
	});
});